export default function() {
  // get the posts matching current filter
  const currentlyShownPosts = document.querySelectorAll(
    ".b-allInsights__item:not(.isHidden)"
  );
  // get button container
  const paginationContainer = document.querySelector(
    ".js-insightsPaginationContainer"
  );

  // clear out contents of container
  paginationContainer.innerHTML = "";

  // count items
  // console.log(`${currentlyShownPosts.length} items to paginate`);

  // figure out how many buttons to add
  const noOfPages = Math.ceil(currentlyShownPosts.length / 5);
  // console.log(`adding ${noOfPages} buttons`);

  // loop over and add buttons
  for (let i = 0, len = noOfPages; i < len; i += 1) {
    const buttonToInsert = document.createElement("a");
    buttonToInsert.textContent = i + 1;
    buttonToInsert.dataset.page = i + 1;
    buttonToInsert.classList.add(
      "b-allInsights__pagination__page",
      "js-insightsPagination"
    );
    paginationContainer.appendChild(buttonToInsert);
  }

  // setup items for pagination
  // loop over and add data attributes to items
  // for (let i = 0, len = noOfPages; i < len; i += 1) {
  //   for (let j = 0, length = 10; j < length; j += 1) {
  //     console.log(`${i+1}-${j+1}`);
  //   }
  // }

  // loop over all the items
  for (let i = 0, len = currentlyShownPosts.length; i < len; i += 1) {
    // add 1 to zero based index for the human friendly number
    const itemNumber = i + 1;
    // derive page number from item number
    const pageNumber = Math.ceil(itemNumber / 5);
    // set data attribute
    currentlyShownPosts[i].dataset.pageno = pageNumber;
  }
}



// WEBPACK FOOTER //
// ./assets/scripts/modules/insightsGeneratePagination.js